import {
  VuexModule,
  Module,
  Mutation,
  Action,
} from "vuex-class-modules"
import { store } from "../store"
import { Modules } from "../modules"
import {
  Alert,
  AlertType,
  ShowAlertConfig
} from "@/models/Alert"
import { PermissionActions, PermissionTypes } from "@/models/PermissionsType"

export enum AlertActions {
  GET_ALERTS = "GET_ALERTS",
  SHOW_ALERT = "SHOW_ALERT",
  SHOW_ERROR_ALERT = "SHOW_ERROR_ALERT",
  CLEAR_REMOVED_ALERTS = "CLEAR_REMOVED_ALERTS",
  CHECK_PERMISSION = "CHECK_PERMISSION",
}

const TIMEOUT = 4000

@Module
class AlertModule extends VuexModule {
  alerts: Alert[] = []
  checkPermissions: {type: PermissionTypes, action: PermissionActions}

  get [`get/${AlertActions.GET_ALERTS}`]() {
    return this.alerts
  }

  get [`get/${AlertActions.CHECK_PERMISSION}`]() {
    return this.checkPermissions
  }

  @Mutation
  setPermissionsType(payload) {
    this.checkPermissions = {
      ...payload
    }
  }

  @Mutation
  addAlert(alert: Alert) {
    this.alerts = [...this.alerts, alert]
  }

  @Mutation
  clearRemovedAlerts() {
    this.alerts = this.alerts.filter(alert => alert.timeout !== -1)
  }

  @Mutation
  updateAlertEstimate(type) {
    const alertToUpdate = this.alerts.find(a => a.uniqueType === type)
    if (alertToUpdate) {
      clearTimeout(alertToUpdate.timeoutCallbackId)
      alertToUpdate.timeout = TIMEOUT
      alertToUpdate.setupTimeout()
    }
  }

  @Action[AlertActions.CHECK_PERMISSION](payload){
    this.setPermissionsType(payload)
  }

  @Action
  [AlertActions.SHOW_ALERT](payload: ShowAlertConfig) {
    const { type = AlertType.SUCCESS, timeout = TIMEOUT, theme, content = [], contentTitle = [], uniqueType, hideDetails, routerLink, queued } = payload
    if (uniqueType && this.alerts.map(a => a.uniqueType).includes(uniqueType)) {
      this.updateAlertEstimate(uniqueType)
    } else {
      this.addAlert(new Alert({
        name,
        content,
        contentTitle,
        type,
        timeout,
        theme,
        uniqueType,
        hideDetails,
        routerLink,
        queued
      }))
    }
  }

  @Action
  [AlertActions.SHOW_ERROR_ALERT](payload: ShowAlertConfig) {
    const { type = AlertType.ERROR, timeout = TIMEOUT, theme, content = [], contentTitle = [], alertRespDetail   } = payload
    this.addAlert(new Alert({
      name,
      type,
      timeout,
      theme,
      content,
      contentTitle,
      alertRespDetail
    }))
  }

  @Action
  [AlertActions.CLEAR_REMOVED_ALERTS]() {
    this.clearRemovedAlerts()
  }
}

export const alertModule = new AlertModule({ store, name: Modules.ALERT })
